import { render } from "./ComparisonTable.vue?vue&type=template&id=568b3b3e&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"

import "./ComparisonTable.vue?vue&type=style&index=0&id=568b3b3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568b3b3e"]])

export default __exports__